<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-1/3">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Название :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.name }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Пользователь воды :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.water_user }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Вышестоящий орган :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.stock_a_authority }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Координаты :
              </p>
              <h5 class="mb-4 ml-2">Широта: {{ resData.lat }}</h5>
              <h5 class="mb-4 ml-2">Долгота: {{ resData.long }}</h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Год постройки :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.year_construction }}
              </h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/3">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Общий резерв :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.total_reserves }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Колчество скважин :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.number_wells }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Колчество активных скважин :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.number_active_wells }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Колчество добытой воды :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.amount_water_received }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Минерализация :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.mineralization }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Жесткость :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.rigidity }}
              </h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/3">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Место рождения:
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.place_birth.name }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Тип использования :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.water_use_type.name }}
              </h5>
            </div>
            <div class="vx-col w-full">
              <p class="text-grey font-bold w-full mb-1">
                Тип водозабора :
              </p>
              <h5 class="mb-4 ml-2">
                {{ resData.water_intake_type.name }}
              </h5>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Info_object",
  data() {
    return {
      resData: null
    };
  },
  created() {
    this.$store
      .dispatch("geology/fetchDetailWaterIntakes", this.$route.params.id)
      .then(res => (this.resData = res.data[0].properties));
  }
};
</script>
